__turbopack_context__.v({
  "root": "InTheBox-module__C6xt3q__root",
  "wrapper": "InTheBox-module__C6xt3q__wrapper",
});
